export function forEachBatch<T>(items: ReadonlyArray<T>, batchSize: number, action: (items: ReadonlyArray<T>, indices: ReadonlyArray<number>) => void) {
    for (let i = 0; i < items.length; i += batchSize) {

        const batch = [];
        const batchIndices = [];

        for (let j = 0; j < batchSize && i + j < items.length; ++j) {
            const currentIndex = i + j;
            batch.push(items[currentIndex]);
            batchIndices.push(currentIndex);
        }

        action(batch, batchIndices);
    }
}
